module.exports = __webpack_public_path__ + "static/media/hand-heart.f21e9ea2.svg";